import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import EditingDocumentInput from '@app/store/editingDocument/EditingDocumentInput';

interface EditingDocumentsFileResponse {
  file: string;
}

/**
 * GET 편집문서 파일 조회
 */
export function getEditingDocumentsFile(
  workspaceId: string,
  editingDocumentId: string
): Promise<EditingDocumentsFileResponse['file']> {
  return requestApi<EditingDocumentsFileResponse>({
    url: withDocument(`/workspaces/${workspaceId}/editing-documents/${editingDocumentId}/file`),
    method: 'GET',
    credentials: true,
  }).then((response) => response.data.file);
}

/**
 * PUT 편집 문서 파일에 필드 추가
 */
export function putEditingDocumentsFile(
  workspaceId: string,
  editingDocumentId: string,
  {
    inputs,
  }: {
    inputs: EditingDocumentInput[];
  }
) {
  return requestApi({
    url: withDocument(`/workspaces/${workspaceId}/editing-documents/${editingDocumentId}/file`),
    method: 'PUT',
    data: {
      inputs,
    },
    credentials: true,
  });
}
